import Vue from "vue";
const vm = Vue.prototype;
import router from "@/router";

import $i18n from "../i18n";
import { getRef, clearRef } from "../utils/referral";

export const state = () => ({
  user: {},
});

export const mutations = {
  SET_USER(state, payload) {
    state.user = payload;
  },
};

export const actions = {
  async SIGN_UP(ctx, { phone, passportNumber, birthDate }) {
    const ref = getRef();
    const res = await vm.$axios.$post("register", {
      phone,
      passportNumber,
      birthDate,
      ref,
    });
    // Member is created + attributed here; consume the token so a later, different
    // applicant on the same browser isn't mis-attributed.
    if (res != null) clearRef();
    return res;
  },

  async FORGOT_PASSWORD(ctx, { phone }) {
    return await vm.$axios.$post("forgot-password", { phone });
  },

  async LOGIN({ dispatch }, { username, password, isSignUpLogin }) {
    let status = $i18n.t("Internal error. (code-{0})", { 0: 0 });

    try {
      const res = await vm.$axios.post("login", { username, password });

      vm.$cookies.set("token", res?.data?.token);
      if (await dispatch("INIT_USER", { isSignUpLogin })) status = null;
    } catch (error) {
      if (error?.response?.data?.error_description) {
        status = error.response.data.error_description;
      } else {
        status = $i18n.t("Internal error. (code-{0})", {
          0: error.response.status,
        });
      }
    }

    return status;
  },

  // GET USER MENU DATA FROM SERVER BUT THAT IS NOT GOOD IDEA
  async GET_USER() {
    const token = vm.$cookies.get("token");
    if (token) {
      const user = await vm.$axios.$get("common/member");
      return user?.id ? user : null;
    } else return null;
  },

  async INIT_USER({ commit }, payload) {
    let status = false;

    const token = vm.$cookies.get("token");
    const isOpen = payload?.isSignUpLogin || router.currentRoute.path == "/";

    console.log("isSignUpLogin", payload?.isSignUpLogin, token);
    if (!token) return status;

    let user = null;
    try {
      const res = await vm.$axios.get("common/member");
      user = res?.data;
    } catch (error) {
      const status_code = error?.response?.status;
      if (status_code === 401) {
        vm.$cookies.remove("token");
        if (router.currentRoute.path != "/") {
          router.replace("/");
        }
      }
      return status;
    }

    if (user?.id) {
      commit("SET_USER", user);
      status = true;

      const onAdmin = () => {
        if (isOpen) {
          vm.$nextTick(() => {
            router.replace("/dashboard");
          });
        }
      };

      const onAccount = () => {
        if (isOpen) {
          vm.$nextTick(() => {
            router.replace("/contract_2022_2023");
          });
        }
      };

      switch (user.role) {
        case "ABITURIENT":
          if (isOpen) {
            vm.$nextTick(() => {
              router.replace("/home");
            });
          }
          break;

        case "ADMIN_OBSERVER":
          onAdmin();
          break;

        case "ADMIN_VERIFIER":
          onAdmin();
          break;

        case "ADMIN_SUPER":
          onAdmin();
          break;
        case "ACCOUNTER":
          onAccount();
          break;
        case "ACCOUNTER_HELPER":
          onAccount();
          break;
        case "QABUL_QILUVCHI":
          onAdmin();
          break;
        case "CONTRACTER":
          onAccount();
          break;
        case "BITRIX_OBSERVER":
          if (isOpen) {
            vm.$nextTick(() => {
              router.replace("/bitrix-monitor");
            });
          }
          break;
        // Bitrix menejeri only ever sees the two contract panels, so /dashboard would land them
        // on a page their permissions hide.
        case "BITRIX_MANAGER":
          if (isOpen) {
            vm.$nextTick(() => {
              router.replace("/contract_2026_2027");
            });
          }
          break;
      }
    } else {
      vm.$cookies.remove("token");
      if (router.currentRoute.path != "/") {
        router.replace("/");
      }
    }

    return status;
  },

  LOGOUT({ commit }) {
    vm.$cookies.remove("token");
    commit("SET_USER", {});

    localStorage.removeItem("admin.iconVer");
    localStorage.removeItem("admin.visiblePanels");
    window.location.replace("/");
  },
};

export const getters = {
  GET_USER: (state) => state.user,
};
